import { t } from "@/i18n";

const ALLOWED = { text: ["image", "video"], reference: ["image", "video"], image: ["image", "video"], video: [] };

const createsCycle = (edges, sourceId, targetId) => {
  const stack = [targetId];
  const seen = new Set();
  while (stack.length) {
    const cur = stack.pop();
    if (cur === sourceId) return true;
    if (seen.has(cur)) continue;
    seen.add(cur);
    edges.filter((e) => e.sourceId === cur).forEach((e) => stack.push(e.targetId));
  }
  return false;
};

export const canConnect = (nodes, edges, sourceId, targetId) => {
  if (sourceId === targetId) return { ok: false, reason: t.canvas.invalid.sameNode };
  const s = nodes.find((n) => n.id === sourceId);
  const g = nodes.find((n) => n.id === targetId);
  if (!s || !g) return { ok: false, reason: "node_missing" };
  if (s.type === "video") return { ok: false, reason: t.canvas.invalid.videoOut };
  if (!ALLOWED[s.type]?.includes(g.type))
    return { ok: false, reason: t.canvas.invalid.type(t.canvas.nodeTypes[s.type], t.canvas.nodeTypes[g.type]) };
  if (edges.some((e) => e.sourceId === sourceId && e.targetId === targetId)) return { ok: false, reason: t.canvas.invalid.duplicate };
  if (createsCycle(edges, sourceId, targetId)) return { ok: false, reason: t.canvas.invalid.cycle };
  return { ok: true };
};

export const hasInputs = (type) => type !== "text" && type !== "reference";
export const hasOutput = (type) => type !== "video";
